import React, { FC } from 'react';
import { LawFirmPopoverInfos, OfficePopover } from '../lawFirm.types';
import { Hyperlink } from '../../components/Hyperlink';
import { EntitiesListItem } from '../../components/entities-card/EntitiesList';
import { UserContextType } from '../../user/user.types';
import { useRestrictedModal } from '../../components/modal/useRestrictedModal';

const pluralizeLawyer = (office: OfficePopover) => `${office.nbLawyers} avocat${
  office.nbLawyers > 1 ? 's ' : ' '
} référencé${office.nbLawyers > 1 ? 's ' : ' '}
`;

type Props = {
  lawFirm: LawFirmPopoverInfos;
  source: string;
  accessPremium: UserContextType['accessPremium'];
};

export const LawFirmOffices: FC<Props> = ({
  lawFirm,
  source,
  accessPremium,
}) => {
  const { openRestrictedModal } = useRestrictedModal();
  return (
    <>
      <EntitiesListItem left="Nombre de bureaux" right={lawFirm.nbOffices} />
      {lawFirm.offices.slice(0, 5).map(office => (
        <EntitiesListItem
          key={office.url}
          left={
            <Hyperlink
              className="search_card__firm__office pointer"
              {...(accessPremium
                ? {
                    href: `${office.url}?source=${source}`,
                  }
                : {
                    onClick: () =>
                      openRestrictedModal({ source: `${source}_office` }),
                  })}
            >
              {office.postalCity}
            </Hyperlink>
          }
          right={pluralizeLawyer(office)}
        />
      ))}
    </>
  );
};
